import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Table , Pagination} from "antd";
import axios from "axios";
import Breadcrumbs from "../../../components/Breadcrumbs";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import SearchBox from "../../../components/SearchBox";
import DepartmentModal from "../../../components/modelpopup/DepartmentModal";
import { base_url } from "../../../base_urls";
import {
  itemRender,
  pageSizeOptions,
  handlePageChange,
  defaultPagination
} from "utils/table";
import {getPosition} from "api/services/common"
import { useSearchParams } from 'react-router-dom';
import { useMediaQuery } from "react-responsive";
import { SkeltonLoader } from "components/skeltonLoader";

import { Button } from "components/Button";



const Designation = () => {
  const [designationData, setDesignationData] = useState([])
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const [pageSettings , setPageSettings] = useState({
    ...defaultPagination,
    page: searchParams.get("page") || 1,
    pageSize: searchParams.get("size") || 50,
    sortType: searchParams.get("sort_type") || "",
    sortBy: searchParams.get("sort_byb") || "",

})
const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
const [view, setView] = useState(isMobile? "grid":"list");


const handleChange = (pagination, filters, sorter) => {
  let pageData = handlePageChange(pagination, filters, sorter, pageSettings)
  console.log(pageData)
  // setSearchParams({
  //     size: pageData?.pageSize,
  //     page: pageData?.page,
  //     sort_by: pageData?.sortBy || "",
  //     sort_type: pageData?.sortType || ""
  // })
  setPageSettings(pageData)
};


const getDesignationList = () => {
  setLoading(true)

  // let _filters = [...filters].filter(item=> item.value)
  // const filter_params = _filters.reduce((acc, item) => {
  //     acc[item.key] = item.value;
  //     return acc;
  //   }, {});
  let filter_params = {}

    
  getPosition({
    sort_by:pageSettings?.sortBy,
    sort_type: pageSettings?.sortType,
    page_size: pageSettings?.pageSize,
    page: pageSettings?.page,
    ...filter_params

  }).then(response=>{
    console.log(response.data.results)
    setDesignationData(response.data.results);
    setPageSettings((prev) => ({
      ...prev,
      total: response.data.count
    }))

    setLoading(false)
  }).catch(e=>{
    setLoading(false)
  })
}
useEffect(()=>{

getDesignationList()

},[pageSettings?.page, pageSettings?.pageSize, pageSettings?.sortBy, pageSettings?.sortType, pageSettings?.filters])



  const columns = [
    {
      title: "Code",
      dataIndex: "code",
      sorter: true,
      // width:   "10%",
    },
    {
      title: "Designation Name",
      dataIndex: "name",
      sorter: (a, b) => true,
      // width: "50%",
    },
    // {
    //   title: "Action",
    //   className: "text-end",
    //   render: () => (
    //     <div className="dropdown dropdown-action text-end">
    //       <Link
    //         to="#"
    //         className="action-icon dropdown-toggle"
    //         data-bs-toggle="dropdown"
    //         aria-expanded="false"
    //       >
    //         <i className="material-icons">more_vert</i>
    //       </Link>
    //       <div className="dropdown-menu dropdown-menu-right">
    //         <Link
    //           className="dropdown-item"
    //           to="#"
    //           data-bs-toggle="modal"
    //           data-bs-target="#edit_designation"
    //         >
    //           <i className="fa fa-pencil m-r-5" /> Edit
    //         </Link>
    //         <Link
    //           className="dropdown-item"
    //           to="#"
    //           data-bs-toggle="modal"
    //           data-bs-target="#delete"
    //         >
    //           <i className="fa fa-trash m-r-5" /> Delete
    //         </Link>
    //       </div>
    //     </div>
    //   ),
    //   sorter: (a, b) => a.length - b.length,
    //   width: "10%",
    // },
  ];

  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else {
      return (
        <>
          {designationData.map((grade, index) => (
            <div className="col-xxl-3 col-xl-4 col-md-6">
            <div className="contact-grid">
                
                <div className="grid-body">
                       
                        <span>
                            {grade?.name}
                        </span>
                       
                   
                </div>
               
            </div>
        </div>
         
          ))}
        </>
      );
    }
  };
  const handleGridChange = (page, size) => {
    setPageSettings({
      ...pageSettings,
      pageSize: size,
      page,
    })
  }

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <Breadcrumbs
            maintitle="Designation"
            title="Dashboard"
            subtitle="Designation"
            modal="#add_designation"
            name="Add Designation"
            view={view}
            setView={setView}
          />
          {/* /Page Header */}
          <div className="row">
            <div className="col-md-12">
            {
                view === "grid" ? 
                <div className="row">
              
                <GridView />
  
                <div className="my-2 d-flex justify-content-end ">
                  <div className="col-sm-12 col-md-6 ">
                  <Pagination
  
                      pageSize={pageSettings?.pageSize}
                      pageSizeOptions={pageSizeOptions}
                      defaultCurrent={1}
                      current={pageSettings?.page}
                      total={pageSettings?.total}
                      // itemRender={itemRender}
                      onChange={handleGridChange}
  
                      showLessItems
                      showSizeChanger={false}
                      showQuickJumper={false}
                      hideOnSinglePage
                      itemRender={(page, type, originalElement) => {
                        if (type === "next") {
                          return (
                            <Button
                              loading={loading}
                              // disabled={loading || (selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id)}
                              className="btn btn-primary "
                              // type="Load More"
                              label="Load More"
                            />
                            
                          );
                        }
                        return null;
                      }}
  
                      />
                  
                  </div>
                </div>
              </div>
              : (
            <div className="row">
              <div className="col-12">
                <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
                  <style>{`
                    .modern-table .ant-table-tbody > tr {
                      background-color: #ffffff !important;
                    }
                    .modern-table .ant-table-tbody > tr:hover > td {
                      background-color: #f5f5f5 !important;
                    }
                    .modern-table .ant-table-thead > tr > th {
                      background-color: #f8f9fa !important;
                      font-weight: 600;
                      color: #333;
                      border-bottom: 2px solid #e0e0e0;
                      padding: 10px 12px;
                      font-size: 13px;
                    }
                    .modern-table .ant-table-tbody > tr > td {
                      border-bottom: 1px solid #f0f0f0;
                      padding: 10px 12px;
                      font-size: 13px;
                    }
                    .modern-table .ant-table-wrapper .ant-table-pagination.ant-pagination {
                      border-top: 1px solid #f0f0f0;
                      background-color: #ffffff;
                      border-bottom-left-radius: 12px;
                      border-bottom-right-radius: 12px;
                    }
                  `}</style>
                  <div className="table-responsive" style={{ overflowX: "auto" }}>
                    <Table
                      className="mb-0 modern-table"
                      style={{ 
                        borderRadius: "12px",
                        minWidth: "100%"
                      }}
                      scroll={{ x: "max-content" }}
                      columns={columns}
                      dataSource={designationData}
                      rowKey={(record) => record.id}
                      loading={loading}
                      pagination={{
                        total: pageSettings?.total,
                        pageSize: pageSettings?.pageSize,
                        showSizeChanger: true,
                        pageSizeOptions: pageSizeOptions,
                        itemRender: itemRender,
                        position: "right",
                        current: pageSettings?.page,
                        showTotal: (total, range) =>
                          `${range[0]}-${range[1]} of ${total} items`,
                        style: { padding: "16px" }
                      }}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
            )
              }
            </div>
          </div>
        </div>
      </div>

      <DepartmentModal />
      <DeleteModal Name="Delete Designation" />
    </>
  );
};

export default Designation;
